module.exports = __webpack_public_path__ + "static/img/ground.55dd4b91.png";